export default __webpack_public_path__ + "static/media/card-theme2.ee4c782e.svg";